<template>
  <div class="more-exit">
    <div class="ha-des">
      <p class="black">问：加入了错误的班级，该如何退出？</p>
      <p>答：您可以直接在班级页面右上角点击“退出班级”</p>
    </div>
    <div class="ha-img">
      <img src="./img/exit.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-exit {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      text-align: center;
      img {
        width: 90%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击加入了错误的班级，该如何退出')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
